export const fadeIn = {
  initial: {
    opacity: 0,
  },
  animate: {
    opacity: 100,
  },
  exit: {
    opacity: 0,
  },
  transition: {
    duration: import.meta.env.VITE_TEST_ENV ? 0 : 0.8,
  },
};

export const fadeFromLeft = {
  initial: {
    opacity: 0,
    x: -50,
  },
  animate: {
    opacity: 100,
    x: 0,
  },
  exit: {
    opacity: 0,
    x: -50,
  },
  transition: {
    duration: 1,
    ease: "easeInOut",
  },
};

export const fadeFromRight = {
  initial: {
    opacity: 0,
    x: 50,
  },
  animate: {
    opacity: 100,
    x: 0,
  },
  exit: {
    opacity: 0,
    x: 50,
  },
  transition: {
    duration: 1,
    ease: "easeInOut",
  },
};

export const fadeFromTop = {
  initial: {
    opacity: 0,
    y: -50,
  },
  animate: {
    opacity: 100,
    y: 0,
  },
  exit: {
    opacity: 0,
    y: -50,
  },
  transition: {
    duration: import.meta.env.VITE_TEST_ENV ? 0 : 0.7,
    ease: "easeInOut",
  },
};
